module.exports = __webpack_public_path__ + "img/profitability4.e17e9a51.png";